import { render, staticRenderFns } from "./InverterCom.vue?vue&type=template&id=9865a370&scoped=true"
import script from "./InverterCom.vue?vue&type=script&lang=js"
export * from "./InverterCom.vue?vue&type=script&lang=js"
import style0 from "./InverterCom.vue?vue&type=style&index=0&id=9865a370&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9865a370",
  null
  
)

export default component.exports